





























































































































import cloneDeep from "lodash/cloneDeep";
import { Prop, Component, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";
import { getAnswers, newAnswer, updateAnswer, Answer } from "@/api/minutes-api";
import AnswerFormData from "@/api/models/AnswerFormData";

interface Option {
  id: number;
  selected: boolean;
  text: string;
}

@Component({
  components: {}
})
export default class MinuteEditPage extends Vue {
  @Prop({ required: true }) projectId!: string;
  @Prop({ default: "" }) answerId?: string;

  entries: FolderEntry[] = [];
  breadcrumbs: Breadcrumb[] = [];
  textcontent: string = "";
  answer: Answer | undefined = newAnswer();
  selecteds: any = [];

  async ok() {
    this.saveAnswer();
    this.goShowPage();
  }

  private async created() {
    if (this.answer == undefined) {
      this.goListPage();
    }
    const res = await getAnswers(this.projectId);
    this.answer = res.find(r => String(r.id) === String(this.answerId));
    if (this.answer == undefined) return;
    for (let i = 0; i < this.answer.answers.length; i++) {
      this.selecteds[this.selecteds.length] = [""];
    }
  }

  disabledAnswer(skip: boolean) {
    if (skip === true) {
      return "background-color:rgba(151,151,151,0.3);";
    } else {
      return "";
    }
  }

  checkValue(text: string) {
    return text.length >= 1 ? true : false;
  }

  checkSelected(options: Option[]) {
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected === true) {
        return true;
      }
    }
    return false;
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  isWorker() {
    return !this.permissions.includes("service/project_read");
  }

  canWriteMinute() {
    return this.permissions.includes("project/minutes_operation");
  }

  canWatchSecret() {
    return !this.permissions.includes("project/minutes_read");
  }

  changeRadioState(index: number, oindex: number) {
    if (this.answer === undefined) return;
    this.answer.answers[index].options.forEach((o, i) => {
      if (oindex === i) {
        o.selected = true;
      } else {
        o.selected = false;
      }
    });
    this.saveAnswer();
  }

  goListPage() {
    const params = {
      projectId: this.projectId
    };
    this.$router.push({ name: "minute-list", params });
  }

  private goShowPage() {
    this.saveAnswer();
    const params = {
      projectId: this.projectId,
      answerId: String(this.answerId)
    };
    this.$router.push({ name: "minute-show", params });
  }

  async saveAnswer() {
    const inAnswer: Answer | undefined = cloneDeep(this.answer);
    if (!inAnswer) {
      return;
    } else {
      for (let i = 0; i < inAnswer.answers.length; i++) {
        if (inAnswer.answers[i].skip === false) {
          if (inAnswer.answers[i].type === "0") {
            // if (!this.checkValue(inAnswer.answers[i].note)) {
            //   inAnswer.answers[i].skip = true;
            // }
          } else {
            const selected: boolean[] = [];
            for (let x = 0; x < inAnswer.answers[i].options.length; x++) {
              selected.push(inAnswer.answers[i].options[x].selected);
            }
            // if (
            //   selected !== [] &&
            //   !selected.includes(true) &&
            //   !this.checkValue(inAnswer.answers[i].note)
            // ) {
            //   inAnswer.answers[i].skip = true; //全ての項目が空の時自動でスキップを入れる
            // }
          }
        }
      }
      const data = AnswerFormData(inAnswer);
      await updateAnswer(data);
    }
  }
}
